module.exports = __webpack_public_path__ + "static/PSA_SysAdmin-ee53cefa81cdfe052879a14900ec8d8e.png";